/**
 * Leave fullscreen if `video` is currently in it. Covers iPhone Safari's native video
 * fullscreen (webkitDisplayingFullscreen / webkitExitFullscreen, not part of the Fullscreen
 * API) and the standard Fullscreen API used by other browsers. No-op otherwise.
 */
export function exitVideoFullscreen(video) {
  if (video?.webkitDisplayingFullscreen && typeof video.webkitExitFullscreen === 'function') {
    video.webkitExitFullscreen();
    return;
  }
  if (document.fullscreenElement && typeof document.exitFullscreen === 'function') {
    document.exitFullscreen().catch(() => {});
  }
}
